<template>
  <div class="app">
    <generic-view
      :title="$t('users')"
      icon="users"
      v-bind:searchable="false"
      v-bind:configurable="false"
      v-bind:show_plus="true"
      :header_buttons="header_buttons"
      v-on:add="create"
      @filter="filter_user"
    >
      <table
        class="ui blue very compact celled striped selectable table"
        ref="table"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>{{ $t("username") }}</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("email") }}</th>
            <th>{{ $t("status") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-view>

    <!-- <template v-for="(mdl, index) in user_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy_modal"
        @init="init"
        :user="user"
      ></component>
    </template> -->
    <user-modal ref="user_modal" @init="init" />
  </div>
</template>

<script>
import { local_api, toast, clone, init_ajax_data_datables } from "@/utils";
// import UserModal from "./UserModal";
import UserModal from "./UserModal";
import GenericView from "@/components/GenericContainer";

export default {
  data() {
    return {
      filter: "",
      processing: false,
      all_users: [],
      users: [],
      user: {},
      // user_modals: [],
      show_inactives: false,
      header_buttons: [
        // {
        //   icon: "eye slash",
        //   tooltip: this.$t("toggle deleted"),
        //   click: this.toggle_inactive,
        // },
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.init,
        },
      ],
    };
  },
  components: {
    UserModal,
    "generic-view": GenericView,
  },
  watch: {
    show_inactives() {
      let color = this.show_inactives ? "grey" : "black";
      this.header_buttons[0].color = color;
    },
  },
  methods: {
    toggle_inactive() {
      this.show_inactives = !this.show_inactives;
    },
    create() {
      this.user = {};
      // this.user_modals.push(UserModal);
      this.$refs.user_modal.show_modal();
    },
    update(user) {
      this.user = user;
      // this.user_modals.push(UserModal);
      this.$refs.user_modal.show_modal(user);
    },
    succedded(user) {
      let idx = this.users.findIndex((n) => n.user_id == user.user_id);
      if (idx >= 0) {
        this.updateAllArray(this.users[idx], "replace");
        this.users.splice(idx, 1, user);
      } else {
        this.updateAllArray(this.users[idx], "add");
        this.users.push(user);
      }
    },
    remove(user, index) {
      let vm = this;
      this.$alertify.confirm(
        vm.$i18n.t("are you sure to delete user?"),
        function () {
          vm.processing = true;
          local_api(vm, "post", "/user/do-delete", {
            i: user.encrypted_id,
          })
            .then(() => {
              vm.updateAllArray(this.users[index], "delete");
              vm.users.splice(index, 1);
            })
            .catch((err) => {
              toast(vm.$el, "error", err);
            })
            .finally(() => {
              vm.processing = false;
            });
        },
        function () {},
      );
    },
    destroy_modal() {
      // this.user_modals = [];
    },
    filter_user(query) {
      if (query == "") this.users = clone(this.all_users);
      else
        this.users = this.all_users.filter(
          (n) =>
            n.name.toUpperCase().includes(query.toUpperCase()) ||
            n.username.toUpperCase().includes(query.toUpperCase()),
        );
    },
    updateAllArray(trgt, action) {
      let tgtIndex = this.all_users.findIndex((u) => u.user_id == trgt.user_id);
      if (action == "add") this.all_users.push(trgt);
      else if (action == "replace") this.all_users.splice(tgtIndex, 1, trgt);
      else if (action == "delete") this.all_users.splice(tgtIndex, 1);
    },
    init() {
      let vm = this;
      /**
       * Datatable
       */
      let columns = [
        {
          data: function (row) {
            return `<i class="blue user icon"></i>${row.username}`;
          },
        },
        {
          data: function (row) {
            return row.name;
          },
        },
        {
          data: function (row) {
            if (row && row.email)
              return `<i class="grey envelope icon"></i>${row.email}`;
            else return "";
          },
        },
        {
          data: function (row) {
            if (row.status_code == "A")
              return `<i class="green check icon"></i>${vm.$t("active")}`;
            else if (row.status_code == "I")
              return `<i class="gray dont icon"></i>${vm.$t("inactive")}`;
            else if (row.status_code == "D")
              return `<i class="red remove icon"></i>${vm.$t("deleted")}`;
            return row.status_code;
          },
        },
      ];

      let onSelect = (data) => {
        vm.update(data);
      };

      let onCreatedRow = (row, data) => {
        if (data.status_code == "D") window.jQuery(row).addClass("negative");
        else if (data.status_code == "I")
          window.jQuery(row).addClass("warning");
      };

      init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["user url"],
        columns,
        onSelect,
        onCreatedRow,
      );
    },
  },
  mounted() {
    this.processing = true;
    let vm = this;
    vm.init();
    // local_api(this, "post", "/user/do-get-all", {})
    //   .then((response) => {
    //     if (response && response.length) {
    //       this.users = response.sort(function(a, b) {
    //         if (a.name > b.name) {
    //           return 1;
    //         }
    //         if (a.name < b.name) {
    //           return -1;
    //         }
    //         return 0;
    //       });
    //       this.all_users = clone(response);
    //     }
    //   })
    //   .catch((err) => {
    //     toast(vm.$el, "error", err);
    //   })
    //   .finally(() => {
    //     vm.processing = false;
    //   });
  },
};
</script>

<style scoped>
.deleted-user {
  background-color: rgb(255, 245, 245) !important;
}
.inactive-user {
  background-color: rgb(243, 243, 243) !important;
}
/* .active-user {
  background-color: rgb(244, 255, 247) !important;
} */
</style>
